import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CredentialsService } from './credentials.service';

@Injectable({ providedIn: 'root' })
export class GuestOnlyGuard {
  private router = inject(Router);
  private credentialsService = inject(CredentialsService);

  canActivate(): boolean | UrlTree {
    return this.credentialsService.isAuthenticated()
      ? this.router.createUrlTree(['/'])
      : true;
  }
}
